import React from 'react'
import { Box } from '@mui/material'
import { makeStyles } from '@mui/styles'

import Companies from './Companies';
import Topics from './Topics';
import Challenges from './Challenges';
import HeroSection from './HeroSection'
import PreparationList from './PreparationList'
import RecentAttempts from './RecentAttempts'
import { AssessmentEntryPoint, CodingRoundScreens } from './constant';
import CreatePersonalizedChallenge from './CreatePersonalizedChallenge';
import FeedbackPendingCard, { FeedbackSkippedCard } from './FeedbackPendingCard';
import { TagCategories } from 'components/Pathway/constants';

const useStyles = makeStyles((theme) => ({
  root : {
    display : 'flex',
    flexDirection : 'column',
    gap : theme.spacing(4),
    width : '100%',
  }
}));

const CodingInterview = () => {
  const classes = useStyles();

  const [activeScreen, setActiveScreen] = React.useState(CodingRoundScreens.HOME);
  const [selectedCompany, setSelectedCompany] = React.useState(null);
  const [selectedSubTopic, setSelectedSubTopic] = React.useState(null);
  
  const [hasPendingAttempt, setHasPendingAttempt] = React.useState(false);
  const [hasSkippedAttempt, setHasSkippedAttempt] = React.useState(false);
  const [pendingAttemptCardShown, setPendingAttemptCardShown] = React.useState(false);
  const [skippedAttemptCardShown, setSkippedAttemptCardShown] = React.useState(false);
  
  const [selectedCard, setSelectedCard] = React.useState({});
  const [entryPoint, setEntryPoint] = React.useState({});

  const handleAttemptStatusCheck = ({ hasPending, hasSkipped }) => {
    if (hasPending && !pendingAttemptCardShown) {
      setHasPendingAttempt(true);
    }
    
    if (hasSkipped && !skippedAttemptCardShown) {
      setHasSkippedAttempt(true);
    }
  };

  const handleClosePendingCard = () => {
    setHasPendingAttempt(false);
    setPendingAttemptCardShown(true);
  };

  const handleCloseSkippedCard = () => {
    setHasSkippedAttempt(false);
    setSkippedAttemptCardShown(true); 
  };

  const handleCardClick = (data) => {
    setSelectedCard(data);
    if(data?.tag){
      setEntryPoint({
        data: data?.tag?.category === TagCategories.COMPANY 
            ? AssessmentEntryPoint.COMPANY : AssessmentEntryPoint.GENERAL_DSA,
        tagId: data.tag._id
      });
      if(data.tag?.category === TagCategories.COMPANY){
        setSelectedCompany(data.tag);
        setSelectedSubTopic({});
        setActiveScreen(CodingRoundScreens.TOPICS);
      }else{
        setSelectedSubTopic(data.tag);
        setSelectedCompany(null);
        setActiveScreen(CodingRoundScreens.CHALLENGES);
      }
    }else{
      setEntryPoint({data: AssessmentEntryPoint.PERSONALIZED, tagId: data._id});
      setActiveScreen(CodingRoundScreens.TOPICS)
    }
  }

  return (
    <Box className={classes.root}>
    {
      activeScreen === CodingRoundScreens.HOME &&
        <>
          {/* {
            hasSkippedAttempt && <FeedbackSkippedCard setSkippedAttempt={handleCloseSkippedCard}/>
          } */}
          {
            hasPendingAttempt && <FeedbackPendingCard setPendingAttempt={handleClosePendingCard}/>
          }
          <HeroSection 
            setActiveScreen={(e)=>{
              setSelectedCard({});
              setActiveScreen(e);
            }}
          />
          <PreparationList
            onClick={handleCardClick}
          />
          <RecentAttempts onAttemptStatusCheck={handleAttemptStatusCheck}/>
          {/* <StarredQuestions /> */}
        </>
    }
    {
      activeScreen === CodingRoundScreens.COMPANIES &&
        <Companies
          setSelected={(e)=>{
            setSelectedCompany(e);
            setActiveScreen(CodingRoundScreens.TOPICS);
            setEntryPoint({data: AssessmentEntryPoint.COMPANY, tagId: e._id});
          }}
          handleBack={()=>setActiveScreen(CodingRoundScreens.HOME)}
          openPersonalized={()=>setActiveScreen(CodingRoundScreens.PERSONALIZED)}
        />
    }
    {
      activeScreen === CodingRoundScreens.TOPICS && 
        <Topics
          initialFilters={selectedCard.details}
          company={selectedCompany}
          setSelected={(e)=>{
            setSelectedSubTopic(e);
            setActiveScreen(CodingRoundScreens.CHALLENGES);
            setEntryPoint({
              data: selectedCompany ? AssessmentEntryPoint.COMPANY : AssessmentEntryPoint.GENERAL_DSA,
              tagId: selectedCompany ? entryPoint.tagId : e._id
            });
          }}
          handleBack={()=>{
            if(selectedCompany){
              setSelectedCompany(null);
              setActiveScreen(CodingRoundScreens.COMPANIES);
            }else{
              setActiveScreen(CodingRoundScreens.HOME);
            }
          }}
        />
    }
    {
      activeScreen === CodingRoundScreens.CHALLENGES && 
        <Challenges
          initialFilters={selectedCard.details}
          entryPoint={entryPoint}
          company={selectedCompany}
          subTopic={selectedSubTopic} 
          handleBack={()=>{
            setSelectedSubTopic(null);
            setActiveScreen(CodingRoundScreens.TOPICS);
          }}
        />
    }
    {
      activeScreen === CodingRoundScreens.PERSONALIZED &&
        <CreatePersonalizedChallenge
          handleBack={()=>{
            setActiveScreen(CodingRoundScreens.COMPANIES);
          }}
        />
    }
    </Box>
  )
}

export default CodingInterview;